import {defineAsyncComponent} from 'vue'
export const getRoutes = (ctx) => {
      return [ {
          name: '_404',
          path: '/404',
          
            meta: {
            ...{},
            
            },
          
          component: () => import('~/core/components/pages/common/error/error.vue')

      },  {
          name: '_',
          path: '/',
          
            meta: {
            ...{},
            
            },
          
          component: () => import('~/core/components/pages/common/home/home.vue')

      },  {
          name: '_account',
          path: '/account',
          
            meta: {
            ...{"account":true,"requiresAuth":true,"private":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/account/account.vue')

      },  {
          name: '_account/address',
          path: '/account/address',
          
            meta: {
            ...{"account":true,"requiresAuth":true,"private":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/address/address.vue')

      },  {
          name: '_account/addresses',
          path: '/account/addresses',
          
            meta: {
            ...{"account":true,"requiresAuth":true,"private":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/address/address.vue')

      },  {
          name: '_account/addresses/_id([0-9]+)/edit',
          path: '/account/addresses/:id([0-9]+)/edit',
          
            meta: {
            ...{"account":true,"requiresAuth":true,"private":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/addressEdit/addressEdit.vue')

      },  {
          name: '_account/addresses/new',
          path: '/account/addresses/new',
          
            meta: {
            ...{"account":true,"requiresAuth":true,"private":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/addressCreate/addressCreate.vue')

      },  {
          name: '_account/address/_id([0-9]+)/edit',
          path: '/account/address/:id([0-9]+)/edit',
          
            meta: {
            ...{"account":true,"requiresAuth":true,"private":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/addressEdit/addressEdit.vue')

      },  {
          name: '_account/address/create',
          path: '/account/address/create',
          
            meta: {
            ...{"account":true,"requiresAuth":true,"private":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/addressCreate/addressCreate.vue')

      },  {
          name: '_account/edit',
          path: '/account/edit',
          
            meta: {
            ...{"account":true,"requiresAuth":true,"private":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/edit/edit.vue')

      },  {
          name: '_account/profile',
          path: '/account/profile',
          
            meta: {
            ...{"account":true,"requiresAuth":true,"private":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/edit/edit.vue')

      },  {
          name: '_account/login',
          path: '/account/login',
          
            meta: {
            ...{"account":true,"guestOnly":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/auth/auth.vue')

      },  {
          name: '_account/password',
          path: '/account/password',
          
            meta: {
            ...{"account":true,"requiresAuth":true,"private":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/password/password.vue')

      },  {
          name: '_account/security',
          path: '/account/security',
          
            meta: {
            ...{"account":true,"requiresAuth":true,"private":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/password/password.vue')

      },  {
          name: '_account/confirm-email-change',
          path: '/account/confirm-email-change',
          
            meta: {
            ...{"account":true,"private":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/edit/edit.vue')

      },  {
          name: '_account/register',
          path: '/account/register',
          
            meta: {
            ...{"account":true,"guestOnly":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/auth/auth.vue')

      },  {
          name: '_account/verify-email',
          path: '/account/verify-email',
          
            meta: {
            ...{"account":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/auth/auth.vue')

      },  {
          name: '_account/verify-email/sent',
          path: '/account/verify-email/sent',
          
            meta: {
            ...{"account":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/auth/auth.vue')

      },  {
          name: '_account/forgot-password',
          path: '/account/forgot-password',
          
            meta: {
            ...{"account":true,"guestOnly":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/auth/auth.vue')

      },  {
          name: '_account/forgot-password/sent',
          path: '/account/forgot-password/sent',
          
            meta: {
            ...{"account":true,"guestOnly":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/auth/auth.vue')

      },  {
          name: '_account/reset-password',
          path: '/account/reset-password',
          
            meta: {
            ...{"account":true,"guestOnly":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/auth/auth.vue')

      },  {
          name: '_account/wishlist',
          path: '/account/wishlist',
          
            meta: {
            ...{"account":true,"private":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/store/wishlist/wishlist.vue')

      },  {
          name: '_account/orders',
          path: '/account/orders',
          
            meta: {
            ...{"account":true,"requiresAuth":true,"private":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/orders/orders.vue')

      },  {
          name: '_account/orders/_id([0-9]+)',
          path: '/account/orders/:id([0-9]+)',
          
            meta: {
            ...{"account":true,"requiresAuth":true,"private":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/orderDetail/orderDetail.vue')

      },  {
          name: '_account/orders/_id([0-9]+)/return',
          path: '/account/orders/:id([0-9]+)/return',
          
            meta: {
            ...{"account":true,"requiresAuth":true,"private":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/orderReturn/orderReturn.vue')

      },  {
          name: '_account/order-history',
          path: '/account/order-history',
          
            meta: {
            ...{"account":true,"requiresAuth":true,"private":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/orders/orders.vue')

      },  {
          name: '_account/success',
          path: '/account/success',
          
            meta: {
            ...{"account":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/account/success/success.vue')

      },  {
          name: '_account/_pathMatch(.*)*',
          path: '/account/:pathMatch(.*)*',
          
            meta: {
            ...{"notFound":true,"private":true,"noindex":true},
            
            },
          
          component: () => import('~/core/components/pages/common/error/error.vue')

      },  {
          name: '_blog/category/_id',
          path: '/blog/category/:id',
          
            meta: {
            ...{},
            
            loader: defineAsyncComponent(() => import('~/core/components//pages/blog/category/category.loader.vue'))
            
            },
          
          component: () => import('~/core/components/pages/blog/category/category.vue')

      },  {
          name: '_blog/post/_id',
          path: '/blog/post/:id',
          
            meta: {
            ...{},
            
            loader: defineAsyncComponent(() => import('~/core/components//pages/blog/post/post.loader.vue'))
            
            },
          
          component: () => import('~/core/components/pages/blog/post/post.vue')

      },  {
          name: '_brands',
          path: '/brands',
          
            meta: {
            ...{},
            
            loader: defineAsyncComponent(() => import('~/core/components//pages/store/manufacturerList/manufacturerList.loader.vue'))
            
            },
          
          component: () => import('~/core/components/pages/store/manufacturerList/manufacturerList.vue')

      },  {
          name: '_contact',
          path: '/contact',
          
            meta: {
            ...{},
            
            },
          
          component: () => import('~/core/components/pages/common/contact/contact.vue')

      },  {
          name: '_page/_id',
          path: '/page/:id',
          
            meta: {
            ...{},
            
            },
          
          component: () => import('~/core/components/pages/common/page/page.vue')

      },  {
          name: '_search/_slug',
          path: '/search/:slug',
          
            meta: {
            ...{},
            
            },
          
          component: () => import('~/core/components/pages/common/search/search.vue')

      },  {
          name: '_store/cart',
          path: '/store/cart',
          
            meta: {
            ...{},
            
            },
          
          component: () => import('~/core/components/pages/store/cart/cart.vue')

      },  {
          name: '_store/checkout',
          path: '/store/checkout',
          
            meta: {
            ...{},
            
            },
          
          component: () => import('~/core/components/pages/store/checkout/checkout.vue')

      },  {
          name: '_store/checkout/success',
          path: '/store/checkout/success',
          
            meta: {
            ...{},
            
            },
          
          component: () => import('~/core/components/pages/store/checkout-success/checkout-success.vue')

      },  {
          name: '_store/category/_id',
          path: '/store/category/:id',
          
            meta: {
            ...{},
            
            loader: defineAsyncComponent(() => import('~/core/components//pages/store/category/category.loader.vue'))
            
            },
          
          component: () => import('~/core/components/pages/store/category/category.vue')

      },  {
          name: '_store/manufacturer/_id',
          path: '/store/manufacturer/:id',
          
            meta: {
            ...{},
            
            loader: defineAsyncComponent(() => import('~/core/components//pages/store/manufacturer/manufacturer.loader.vue'))
            
            },
          
          component: () => import('~/core/components/pages/store/manufacturer/manufacturer.vue')

      },  {
          name: '_store/manufacturer',
          path: '/store/manufacturer',
          
            meta: {
            ...{},
            
            loader: defineAsyncComponent(() => import('~/core/components//pages/store/manufacturerList/manufacturerList.loader.vue'))
            
            },
          
          component: () => import('~/core/components/pages/store/manufacturerList/manufacturerList.vue')

      },  {
          name: '_store/product/_id',
          path: '/store/product/:id',
          
            meta: {
            ...{},
            
            loader: defineAsyncComponent(() => import('~/core/components//pages/store/product/product.loader.vue'))
            
            },
          
          component: () => import('~/core/components/pages/store/product/product.vue')

      },  {
          name: '_store/special',
          path: '/store/special',
          
            meta: {
            ...{},
            
            loader: defineAsyncComponent(() => import('~/core/components//pages/store/special/special.loader.vue'))
            
            },
          
          component: () => import('~/core/components/pages/store/special/special.vue')

      }, ]
  }
